import { FeedPost } from '../types/feed';

export const mockFeedPosts: FeedPost[] = [
  {
    id: '1',
    author: {
      id: 'user-1',
      name: 'Emma Wilson',
      avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=96&q=80',
    },
    location: 'Santorini, Greece',
    imageUrls: [
      'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?auto=format&fit=crop&w=600&q=80',
    ],
    caption: 'Blue domes, white walls, endless caldera views. Our full 4-day Santorini route is saved below.',
    likes: 156,
    comments: 23,
    savedCount: 5,
    badge: 'Save trip',
    createdAt: '2026-07-02T07:00:00Z',
  },
  {
    id: '2',
    author: {
      id: 'user-2',
      name: 'Mike Chen',
      avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=96&q=80',
    },
    location: 'Kyoto, Japan',
    imageUrl: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=900&q=80',
    caption: 'Beat the crowds: temple gates at dawn, completely silent.',
    likes: 89,
    comments: 12,
    createdAt: '2026-07-02T05:00:00Z',
  },
  {
    id: '3',
    author: {
      id: 'user-3',
      name: 'Sarah Johnson',
      avatarUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=96&q=80',
    },
    location: 'Asked the community',
    caption: '3 days in Lisbon in October — which neighborhood should I base myself in?',
    likes: 42,
    comments: 31,
    badge: 'Question',
    createdAt: '2026-07-01T18:00:00Z',
  },
];
